import { request } from "/src/utils/index.js";

export function Search(params) {
  return request.get("tcm/prescription/list", { params });
}

export function EmployeeList(params) {
  return request.get("sdcom/employee/list", { params });
}

export function ClubList(params) {
  return request.get("b2b/business/club/relation/list", { params });
}

export function SubjectList(params) {
  return request.get("sdcom/object/subject/list/standard", { params });
}
export function EditSubjectObject(params) {
  return request.put("/sdcom/object/subject/items", params);
}
export function DoctorSetting(params) {
  return request.put("sdapp/schedule/doctor/setting", params);
}
export function EmployeeEdit(params) {
  return request.put("sdcom/employee", params);
}

export function SearchSchedule(params) {
  return request.get("sdapp/schedule/doctor/section/schedule/map", { params });
}

export function EditSchedule(params) {
  return request.put("sdapp/schedule/doctor/section/schedule/batch", params);
}

export function CopySchedule(params) {
  return request.post("sdapp/schedule/doctor/section/schedule/copy", params);
}

export function Detail(params) {
  return request.get("tcm/prescription/ai/list", { params });
}

export function Add(params) {
  return request.post("tcm/prescription/ai", params);
}

export function Update(params) {
  return request.put("tcm/prescription/", params);
}

export function Delete(data) {
  return request.delete("tcm/prescription/ai", { data });
}


export function DailySummary(params) {
  return request.get("sdbs/appointment/list/club/DailySummary", { params });
}